import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';

const LoadingContainer = styled.div`
  background: #f3f4f6;
  color: #6b7280;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.span`
  flex: 1;
  font-size: 0.875rem;
`;

const ProgressDots = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

const Dot = styled.div`
  width: 4px;
  height: 4px;
  background: #6b7280;
  border-radius: 50%;
  animation: ${props => props.delay ? `pulse 1.5s ease-in-out ${props.delay}s infinite` : 'none'};
  
  @keyframes pulse {
    0%, 100% { opacity: 0.6; }
    50% { opacity: 1; }
  }
`;

const ImprovedLoadingBar = ({ 
  loanId, 
  message = "Loading existing data for loan",
  showSpinner = true,
  showDots = true,
  variant = 'default',
  ...props 
}) => {
  
  const getVariantStyles = () => {
    switch (variant) {
      case 'subtle':
        return {
          background: '#f9fafb',
          color: '#9ca3af'
        };
      case 'warning':
        return {
          background: '#fef3c7',
          color: '#92400e'
        };
      default:
        return {};
    }
  };
  
  return (
    <LoadingContainer 
      style={getVariantStyles()}
      {...props}
    >
      {showSpinner && <LoadingSpinner />}
      <LoadingText>
        {message} {loanId}...
      </LoadingText>
      {showDots && (
        <ProgressDots>
          <Dot delay={0} />
          <Dot delay={0.2} />
          <Dot delay={0.4} />
        </ProgressDots>
      )}
    </LoadingContainer>
  );
};

export default ImprovedLoadingBar;
